import { Component, Input,  QueryList, ViewChildren, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MessageService, FormsUtilsService, notCloseMessageOptions } from '../../../../core';
import { GrupoClassificacaoClassificacao } from '../grupo-classificacao-classificacao';
import { TipoClassificacaoSelectComponent } from '../../../tipo-classificacao/select';
import { ClassificacaoSelectComponent } from '../../../classificacao/select';
import { isSituacaoAtivo, isSituacaoInativo } from '../../situacao';

interface Config {
    /** Se deve forçar a obrigatoriedade das classificações */
    forceObrigatorio: boolean;
}

@Component({
    selector: 'sgt-grupo-classificacao-classificacao-form',
    templateUrl: './grupo-classificacao-classificacao-form.component.html',
    styleUrls: ['./grupo-classificacao-classificacao-form.component.less']
})
export class GrupoClasssificacaoItemClassificacaoFormComponent implements OnChanges {
    config: Config;

    /** Classificações da Meta */
    @Input() entities: GrupoClassificacaoClassificacao[];
    /** Situação do Grupo de Classificação */
    @Input() situacaoGrupoClassificacao: number;
    /** Se pode editar as classificações da meta */
    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;
    /** Selects dos tipos das classificações */
    @ViewChildren('tipoClassificacaoSelect') tipoClassificacaoSelect: QueryList<TipoClassificacaoSelectComponent>;
    /** Selects das classificações */
    @ViewChildren('classificacaoSelect') classificacaoSelect: QueryList<ClassificacaoSelectComponent>;

    constructor(private messageService: MessageService,
                private formsUtilsService: FormsUtilsService) { }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'situacaoGrupoClassificacao') {
                this.onChangeSituacaoGrupoClassificacao();
            }
        };
    }

    private setConfig() {
        this.config = {
            forceObrigatorio: this.forceObrigatorio(),
        }
    }

    /** Verifica se deve forçar a obrigatoriedade das classificações */
    private forceObrigatorio(): boolean {
        return isSituacaoAtivo(this.situacaoGrupoClassificacao) || isSituacaoInativo(this.situacaoGrupoClassificacao);
    }

    /** Ao alterar a situação do grupo de classificação */
    private onChangeSituacaoGrupoClassificacao() {
        // Atualizando as configs
        this.setConfig();

        // Se for para forçar a obrigatoriedade das classificações então alteramos todas para obrigatório = true
        if (this.config.forceObrigatorio) {
            this.entities?.forEach(entity => entity.obrigatorio = true);
        }
    }

    insert(setFocus: boolean = true) {
        const entity = new GrupoClassificacaoClassificacao();
        this.entities.push(entity);

        if (setFocus) {
            setTimeout(() => this.tipoClassificacaoSelect?.last?.setFocus(), 200);
        }
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir esse segmento do grupo?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Ao alterar o tipo da classificação */
    onChangeTipoClassificacao(entity: GrupoClassificacaoClassificacao) {
        if (!entity) {
            return;
        }

        entity.idClassificacao = null;
        entity.classificacao = null;
    }

    /** Ao alterar a classificação */
    onChangeClassificacao(entity: GrupoClassificacaoClassificacao) {
        if (!entity) {
            return;
        }

        if (entity.idClassificacao) {
            entity.obrigatorio = true;
        }
    }

    /** Verifica as classificações estão válidos */
    isValid(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Nenhuma classificação
        if (!this.entities || this.entities.length === 0) {
            this.messageService.warning('É necessário adicionar pelo menos um segmento ao grupo', 'Atenção', notCloseMessageOptions);
            this.insert();
            return false;
        }

        // Duplicações
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            // Tipo de classificação
            if (!entity.idTipoClassificacao) {
                this.messageService.warning('É necessário selecionar o tipo do segmento ou remover este registro', 'Atenção', notCloseMessageOptions);
                this.tipoClassificacaoSelect?.toArray()[i]?.setFocus();
                return false;
            }
            // Tipo de classificação duplicado
            const countTipoClassificacao = this.entities.filter(entityFilter => entityFilter.idTipoClassificacao && entityFilter.idTipoClassificacao === entity.idTipoClassificacao).length;
            if (countTipoClassificacao > 1) {
                this.messageService.warning(`O tipo do segmento ${entity?.tipoClassificacao?.nome} já está adicionado. Remova ou altere o tipo duplicado`, 'Não é possível adicionar dois tipos iguais', notCloseMessageOptions);
                this.tipoClassificacaoSelect?.toArray()[i]?.setFocus();
                return false;
            }

            // Classificação duplicada
            const countClassificacao = this.entities.filter(entityFilter => entityFilter.idClassificacao && entityFilter.idClassificacao === entity.idClassificacao).length;
            if (countClassificacao > 1) {
                this.messageService.warning(`O segmento ${entity?.classificacao?.nome} já está adicionado. Remova ou altere o segmento duplicado`, 'Não é possível adicionar dois segmentos iguais', notCloseMessageOptions);
                this.classificacaoSelect?.toArray()[i]?.setFocus();
                return false;
            }
        }

        // Form
        if (!this.form.valid) {
            this.messageService.warning('Preencha corretamente os segmentos do grupo', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
